import { LiveDot } from "@design-system/LiveDot/LiveDot";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import type { AgentRunStatus } from "./agentRunStatus";
import styles from "./AgentRunStatusDot.module.scss";

/** The run's status as a dot: live while running, toned and labelled otherwise. */
export const AgentRunStatusDot = ({ status }: { status: AgentRunStatus }) => (
    <Tooltip content={status.tooltip}>
        {status.dot === "accent" ? (
            <LiveDot
                size="xs"
                variant="accent"
                label={status.label}
                className={styles.statusDot}
            />
        ) : (
            <span
                role="img"
                aria-label={status.label}
                className={styles.statusDot}
                data-tone={status.dot}
            />
        )}
    </Tooltip>
);
